import { COLUMN_KEYS, COLUMN_LABELS } from "constants/table";

export const ERROR_TYPE = {
  ACTIVE: true,
  HISTORICAL: false,
};

export const RESOLVE_ACTION = {
  RETRY: 1,
  SKIP_PROCESS: 2,
  REMOVE_UNIT: 3,
};

export const FIELD_KEYS = {
  ...COLUMN_KEYS,
  ERROR_CODE: "error_code",
  ERROR_DATE_TIME: "error_date_time",
  ERROR_DETAILS: "error_details",
  ERROR_TYPE: "is_active",
  ITEM_REF_NO: "item_ref_no",
  UNIT_START_DATE_TIME: "unit_start_date_time",
  UNIT_STATUS: "unit_status",
  UNIT_X: "unit_x",
  POTENTIAL_CAUSES: "potential_causes",
  PRODUCT: "product",
  RECOMMENDED_ACTIONS: "recommended_actions",
  RESOLVE_ACTION: "resolve_action",
  RESOLVER: "resolver",
};

export const FIELD_LABELS = {
  ...COLUMN_LABELS,
  [FIELD_KEYS.ERROR_CODE]: "Error Code",
  [FIELD_KEYS.ERROR_DATE_TIME]: "Error Date Time",
  [FIELD_KEYS.ERROR_DETAILS]: "Error Details",
  [FIELD_KEYS.ERROR_TYPE]: "Error Type",
  [FIELD_KEYS.ITEM_REF_NO]: "Item Ref No",
  [FIELD_KEYS.UNIT_START_DATE_TIME]: "Unit Start Date Time",
  [FIELD_KEYS.UNIT_STATUS]: "Unit Status",
  [FIELD_KEYS.UNIT_X]: "Unit x",
  [FIELD_KEYS.POTENTIAL_CAUSES]: "Potential Causes",
  [FIELD_KEYS.PRODUCT]: "Product",
  [FIELD_KEYS.RECOMMENDED_ACTIONS]: "Recommended Actions",
  [FIELD_KEYS.RESOLVE_ACTION]: "Resolve Action",
  [FIELD_KEYS.RESOLVER]: "Resolver",
};

export const FIELD_ORDERS = [
  FIELD_KEYS.NO,
  FIELD_KEYS.PRODUCT,
  FIELD_KEYS.ITEM_REF_NO,
  FIELD_KEYS.UNIT_X,
  FIELD_KEYS.UNIT_STATUS,
  FIELD_KEYS.UNIT_START_DATE_TIME,
  FIELD_KEYS.ERROR_DATE_TIME,
  FIELD_KEYS.ERROR_CODE,
  FIELD_KEYS.ERROR_DETAILS,
  FIELD_KEYS.POTENTIAL_CAUSES,
  FIELD_KEYS.RECOMMENDED_ACTIONS,
  FIELD_KEYS.RESOLVE_ACTION,
  FIELD_KEYS.RESOLVER,
  FIELD_KEYS.ACTION,
];

export const TABLE_FIELDS = [
  FIELD_KEYS.ACTION,
  FIELD_KEYS.ERROR_CODE,
  FIELD_KEYS.ERROR_DATE_TIME,
  FIELD_KEYS.ERROR_DETAILS,
  FIELD_KEYS.ITEM_REF_NO,
  FIELD_KEYS.UNIT_START_DATE_TIME,
  FIELD_KEYS.UNIT_X,
  FIELD_KEYS.NO,
  FIELD_KEYS.PRODUCT,
  FIELD_KEYS.RESOLVE_ACTION,
  FIELD_KEYS.RESOLVER,
];

export const TABLE_SORTABLE_FIELDS = [
  FIELD_KEYS.ERROR_CODE,
  FIELD_KEYS.ERROR_DATE_TIME,
  FIELD_KEYS.ITEM_REF_NO,
  FIELD_KEYS.UNIT_START_DATE_TIME,
  FIELD_KEYS.UNIT_X,
  FIELD_KEYS.PRODUCT,
  FIELD_KEYS.RESOLVER,
];

export const HISTORICAL_ONLY_FIELDS = [
  FIELD_KEYS.RESOLVE_ACTION,
  FIELD_KEYS.RESOLVER,
];

export const DETAIL_FIELDS = [
  FIELD_KEYS.ERROR_CODE,
  FIELD_KEYS.ERROR_DETAILS,
  FIELD_KEYS.ITEM_REF_NO,
  FIELD_KEYS.UNIT_STATUS,
  FIELD_KEYS.UNIT_X,
  FIELD_KEYS.POTENTIAL_CAUSES,
  FIELD_KEYS.RECOMMENDED_ACTIONS,
];
